import React from "react";
import { useParams } from "react-router-dom";
import FinancialStatement from "./FinancialStatement";
import { cashFlowData } from "../api/financialsData"; // Import the API call

export default function CashFlow() {
	const { symbol } = useParams();

	return (
		<FinancialStatement
			fetchDataFunction={cashFlowData}
			statement={"Cash Flow"}
			symbol={symbol}
		></FinancialStatement>
	);
}
